import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { Url } from '@wix/da-url';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import SophisticatedTooltip from '../../../Popover/Preset/SophisticatedTooltip';
import SubscribeToUnlockTooltip from '../SubscribeToUnlockTooltip';
import s from './SubscribersOnly.scss';
// This gets "you've unlocked this content" on one line while wrapping title
var CONSTRAINED_TITLE_MAX_LENGTH = 28;
var CONSTRAINED_TITLE_WIDTH_PX = 256;
var SubscribersOnly = function (_a) {
    var _b;
    var deviation = _a.deviation, className = _a.className;
    var t = useTranslation().t;
    var _c = useSubscriptionTier(deviation), member_subscriptions = _c.member_subscriptions, tier = _c.tier, isTier = _c.isTier, isUserSubscribed = _c.isUserSubscribed, isOwner = _c.isOwner, isBlockedBySubscription = _c.isBlockedBySubscription;
    if (!member_subscriptions || !tier || !tier.author) {
        return null;
    }
    var heading;
    switch (getDeviationType(deviation)) {
        case DeviationTypes.JOURNAL:
            heading = t('deviation.tier.subscribersOnly.tooltip.unlockedJournal');
            break;
        case DeviationTypes.STATUS:
            heading = t('deviation.tier.subscribersOnly.tooltip.unlockedPost');
            break;
        default:
            heading = t('deviation.tier.subscribersOnly.tooltip.unlockedContent');
    }
    var contents = (React.createElement("div", { className: s['contents'] },
        React.createElement(TierBadge, { size: 40 }),
        React.createElement("span", { className: s['text'] }, t('deviation.tier.subscribersOnly'))));
    var isAnUnsubscribedTier = isTier && !isUserSubscribed && !isOwner;
    var hasLongTitle = (((_b = tier === null || tier === void 0 ? void 0 : tier.title) === null || _b === void 0 ? void 0 : _b.length) || 0) > CONSTRAINED_TITLE_MAX_LENGTH;
    var viewTiersUrl = Url.userLink(tier.author.username, '/subscriptions');
    return (React.createElement("div", { className: classnames(s['root'], className) }, isBlockedBySubscription || isAnUnsubscribedTier ? (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation }, contents)) : (React.createElement(SophisticatedTooltip, { size: "large", placement: "top", width: hasLongTitle ? CONSTRAINED_TITLE_WIDTH_PX : undefined, heading: heading, description: tier.title, postfix: React.createElement(SophisticatedTooltipLink, { href: viewTiersUrl, className: s['subs-link'] }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink')) }, contents))));
};
SubscribersOnly.displayName = 'SubscribersOnly';
export default SubscribersOnly;
//# sourceMappingURL=SubscribersOnly.js.map